import React, { useEffect, useMemo, useState } from 'react';
import MyButton from '../../../components/MyButton';
import MyModal from '../../../components/MyModal';
import { validateEventDraft } from '../../../helpers/eventsBulkAutofill';
import {
  EVENT_FIELDS,
  applyFieldValue,
  getFieldValue,
  isFieldIrrelevant,
  isFieldLocked,
} from '../constants';
import EventFieldEditor from './EventFieldEditor';

function lockedValueText(draft, field) {
  const value = getFieldValue(draft, field);
  if (Array.isArray(value)) return value.map((item) => item.name || item).filter(Boolean).join(', ') || '—';
  if (value && typeof value === 'object') return value.name || '—';
  return value || '—';
}

function EventEditModal({
  isOpen,
  draft,
  index,
  config,
  categories,
  countries,
  languages,
  onClose,
  onSave,
}) {
  const [localDraft, setLocalDraft] = useState(draft);

  useEffect(() => {
    setLocalDraft(draft);
  }, [draft?.uid, isOpen]);

  const errors = useMemo(() => (localDraft ? validateEventDraft(localDraft) : []), [localDraft]);
  if (!localDraft) return null;

  return (
    <MyModal isOpen={isOpen} closeFunction={onClose} style={{ width: 'min(760px, 94vw)' }}>
      <div className="bulk_offers_edit_modal">
        <div className="bulk_offers_edit_modal_head">
          <p className="bulk_offers_edit_modal_title">
            {`Мероприятие #${index + 1}${localDraft.name ? ` — ${localDraft.name}` : ''}`}
          </p>
          {errors.length ? (
            <p className="bulk_offers_card_status invalid">{`Не готово: ${errors.length}`}</p>
          ) : (
            <p className="bulk_offers_card_status ready">Готово к созданию</p>
          )}
        </div>

        <div className="bulk_offers_edit_modal_body">
          {EVENT_FIELDS.map((field) => {
            if (isFieldIrrelevant(field, localDraft)) return null;
            if (isFieldLocked(field, config)) {
              return (
                <div key={field.key} className="bulk_offers_edit_field">
                  <p className="bulk_offers_edit_field_label">
                    {field.label}
                    <span className="bulk_offers_edit_field_locked">закреплено режимом</span>
                  </p>
                  <p className="bulk_offers_edit_field_locked_value">{lockedValueText(localDraft, field)}</p>
                </div>
              );
            }
            return (
              <div key={field.key} className="bulk_offers_edit_field">
                <p className="bulk_offers_edit_field_label">{field.label}</p>
                <EventFieldEditor
                  key={`${localDraft.uid}_${field.key}`}
                  field={field}
                  value={getFieldValue(localDraft, field)}
                  onChange={(value) => setLocalDraft((prev) => applyFieldValue(prev, field, value))}
                  draft={localDraft}
                  categories={categories}
                  countries={countries}
                  languages={languages}
                  config={config}
                />
              </div>
            );
          })}
          {errors.length ? (
            <ul className="bulk_offers_card_errors">
              {errors.map((error) => <li key={error}>{error.replace(/^\s*\*\s*/, '')}</li>)}
            </ul>
          ) : null}
        </div>

        <div className="bulk_offers_edit_modal_actions">
          <MyButton text="Отмена" onClick={onClose} secondary className="bulk_offers_modal_button" />
          <MyButton text="Сохранить" onClick={() => onSave(localDraft)} className="bulk_offers_modal_button" />
        </div>
      </div>
    </MyModal>
  );
}

export default EventEditModal;
